var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchAwsNitroEnclaves32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/32/Arch_AWS-Nitro-Enclaves_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8511B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/32/Arch_AWS-Nitro-Enclaves_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-BG/32/Compute",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.771,23 L19.4,23 C19.551,23 19.695,23.069 19.79,23.187 C19.885,23.306 19.921,23.46 19.888,23.608 L19.221,26.61 L23.228,21 L20.599,21 C20.448,21 20.304,20.931 20.209,20.813 C20.114,20.694 20.078,20.54 20.111,20.392 L20.778,17.39 L16.771,23 Z M18.2,29.4 C18.131,29.4 18.062,29.386 17.996,29.356 C17.779,29.26 17.66,29.023 17.711,28.792 L18.777,24 L15.799,24 C15.612,24 15.441,23.896 15.355,23.729 C15.269,23.562 15.284,23.362 15.392,23.209 L21.392,14.81 C21.531,14.617 21.786,14.548 22.003,14.644 C22.22,14.74 22.339,14.977 22.288,15.208 L21.222,20 L24.2,20 C24.387,20 24.558,20.104 24.644,20.271 C24.73,20.438 24.715,20.638 24.607,20.791 L18.607,29.19 C18.51,29.325 18.357,29.4 18.2,29.4 L18.2,29.4 Z M12,33 L28,33 L28,13.5 C28,13.224 28.223,13 28.5,13 L30,13 L30,7 L27,7 L27,9.5 C27,9.776 26.776,10 26.5,10 L22.5,10 C22.223,10 22,9.776 22,9.5 L22,7 L18,7 L18,9.5 C18,9.776 17.776,10 17.5,10 L13.5,10 C13.223,10 13,9.776 13,9.5 L13,7 L10,7 L10,13 L11.5,13 C11.776,13 12,13.224 12,13.5 L12,33 Z M28.5,34 L11.5,34 C11.223,34 11,33.776 11,33.5 L11,14 L9.5,14 C9.223,14 9,13.776 9,13.5 L9,6.5 C9,6.224 9.223,6 9.5,6 L13.5,6 C13.776,6 14,6.224 14,6.5 L14,9 L17,9 L17,6.5 C17,6.224 17.223,6 17.5,6 L22.5,6 C22.776,6 23,6.224 23,6.5 L23,9 L26,9 L26,6.5 C26,6.224 26.223,6 26.5,6 L30.5,6 C30.776,6 31,6.224 31,6.5 L31,13.5 C31,13.776 30.776,14 30.5,14 L29,14 L29,33.5 C29,33.776 28.776,34 28.5,34 L28.5,34 Z",
    id: "AWS-Nitro-Enclaves_Icon_32_Squid",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchAwsNitroEnclaves32);
export default __webpack_public_path__ + "static/media/Arch_AWS-Nitro-Enclaves_32.e6a208e21cf9f4ade8535b5e5254f853.svg";
export { ForwardRef as ReactComponent };